import { PermissionSchema, type Permission as GeneratedPermission } from '~/services/api/generated'

export type Permission = GeneratedPermission

export const Permission = {
  VIEW_USERS: PermissionSchema.enum['view users'],
  CREATE_USERS: PermissionSchema.enum['create users'],
  EDIT_USERS: PermissionSchema.enum['edit users'],
  DELETE_USERS: PermissionSchema.enum['delete users'],
  VIEW_ORGANIZER_USERS: PermissionSchema.enum['view organizer users'],
  CREATE_ORGANIZER_USERS: PermissionSchema.enum['create organizer users'],
  EDIT_ORGANIZER_USERS: PermissionSchema.enum['edit organizer users'],
  DELETE_ORGANIZER_USERS: PermissionSchema.enum['delete organizer users'],
  VIEW_ORGANIZER_ORDERS: PermissionSchema.enum['view organizer orders'],
  MANAGE_ORGANIZER_ORDERS: PermissionSchema.enum['manage organizer orders'],
  VIEW_PARTNERS: PermissionSchema.enum['view partners'],
  CREATE_PARTNERS: PermissionSchema.enum['create partners'],
  EDIT_PARTNERS: PermissionSchema.enum['edit partners'],
  DELETE_PARTNERS: PermissionSchema.enum['delete partners'],
  VIEW_BRANDS: PermissionSchema.enum['view brands'],
  CREATE_BRANDS: PermissionSchema.enum['create brands'],
  EDIT_BRANDS: PermissionSchema.enum['edit brands'],
  DELETE_BRANDS: PermissionSchema.enum['delete brands'],
  VIEW_STORES: PermissionSchema.enum['view stores'],
  CREATE_STORES: PermissionSchema.enum['create stores'],
  EDIT_STORES: PermissionSchema.enum['edit stores'],
  DELETE_STORES: PermissionSchema.enum['delete stores'],
  VIEW_MENUS: PermissionSchema.enum['view menus'],
  CREATE_MENUS: PermissionSchema.enum['create menus'],
  EDIT_MENUS: PermissionSchema.enum['edit menus'],
  DELETE_MENUS: PermissionSchema.enum['delete menus'],
  ASSIGN_MENUS_TO_STORE: PermissionSchema.enum['assign menus to store'],
  VIEW_ORDERS: PermissionSchema.enum['view orders'],
  CREATE_ORDERS: PermissionSchema.enum['create orders'],
  EDIT_ORDERS: PermissionSchema.enum['edit orders'],
  DELETE_ORDERS: PermissionSchema.enum['delete orders'],
  UPDATE_ORDER_STATUS: PermissionSchema.enum['update order status'],
  VIEW_PAYMENTS: PermissionSchema.enum['view payments'],
  CREATE_PAYMENTS: PermissionSchema.enum['create payments'],
  EDIT_PAYMENTS: PermissionSchema.enum['edit payments'],
  DELETE_PAYMENTS: PermissionSchema.enum['delete payments'],
  VIEW_PAYOUT_ACCOUNT: PermissionSchema.enum['view payout account'],
  CREATE_PAYOUT_ACCOUNTS: PermissionSchema.enum['create payout accounts'],
  EDIT_PAYOUT_ACCOUNTS: PermissionSchema.enum['edit payout accounts'],
  VIEW_PAYOUTS: PermissionSchema.enum['view payouts'],
  CREATE_PAYOUTS: PermissionSchema.enum['create payouts'],
  EDIT_PAYOUTS: PermissionSchema.enum['edit payouts'],
  DELETE_PAYOUTS: PermissionSchema.enum['delete payouts'],
  VIEW_REPORTS: PermissionSchema.enum['view reports'],
  EXPORT_DATA: PermissionSchema.enum['export data']
} satisfies Record<string, GeneratedPermission>

export const PermissionValues: readonly GeneratedPermission[] = Object.values(Permission)
